const translations = {
  "en": {
    "Cancel": "Cancel",
    "Search": "Search"
  },
  "zh-tw": {
    "Cancel": "取消",
    "Search": "搜尋"
  }
};

export default translations;
